<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="u-window record-modal">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-record">历史订单</div>
                    <div class="record-view">
                        <div class="table-header flex-between-center">
                            <div class="table-item" style="width: 320px;">商品</div>
                            <div class="table-item" style="width: 100px;">价格</div>
                            <div class="table-item pay-item">时间</div>
                        </div>

                        <div class="data-view">
                            <vuescroll>
                                <div class="table-item flex-between-center" v-for="(item,index) in list" :key="index">
                                    <div class="tr-item">
                                        <div class="goods-list flex-wrap">
                                            <div class="reward-item flex-start-center" v-for="(r,k) in item.giftList" :key="k">
                                                <div class="reward-pic" v-tips="r.gameGiftId">
                                                    <game-item :locked="true" :id="r.gameGiftId" :num="r.sendNum"></game-item>
                                                </div>

                                                <div>*{{ r.num }}</div>
                                            </div>

                                        </div>

                                        
                                    </div>
                                    <div class="tr-item" style="width: 100px;">{{ item.payAmount }}<em :class="{ 'icon-m3b' : item.payType == 1 , 'icon-token' : item.payType == 2 }"></em></div>
                                    <!-- <div class="tr-item pet-name text-overflow-1">{{ item.remark }}</div> -->
                                    <div class="tr-item pay-item">{{ item.payTime.slice(5,16) }}</div>
                                </div>
                            </vuescroll>

                        </div>
                    </div>                    
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.record-modal .dialog-content{
    padding: 20px 0 30px 0;
}

.t-record{

}

.record-view{
    .pay-item{
        width: 72px;
        text-align: center;
    }
}


.table-header{
    width: 100%;
    margin-bottom: 14px;
    padding: 12px 18px 12px 36px;
    font-size: 24px;
    color: #666565;
    background-color: #fcf7e4;
}

.data-view{
    height: 490px;
    .table-item{
        width: 100%;       
        margin: 0 auto 8px;
        padding: 12px 20px;
        background-color: #fcf7e4;
    }

    .tr-item{
        color: #9d9593;
        text-align: center;
        word-break: break-all;
    }

    .goods-list{
        width: 304px;
    }

    .reward-pic{
        width: 68px;
        height: 68px;
        margin: 0 5px 10px;
    }
}
</style>

<script>
export default {
    data () {
        return {
            visible : false,
            list : [],
            ops: {
                rail: {
                    opacity: 0.6,
                    background: '#e7e5d8',
                    size: '6px',
                    gutterOfSide: '0px',
                },
                bar: {
                    background: '#ffcc43',
                    keepShow: true,
                    size: '6px',
                }
            },

        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){   
        document.body.style.overflow = 'hidden';
    },  
    methods : {
        destroyElement () {
            this.$destroy()
            document.body.style.overflow = ''; // 出现滚动条
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },       
    },    
}
</script>